import React from "react";
import FormText from "./form/formText.component";
import ContainerBox from "./common/containerBox.component";
import { useDispatch, useSelector } from "react-redux";
import { enterAcntHolderName } from "../actions/index";
import { stateProps } from "../types";
import FormSingleInput from "./form/formSingleInput.component";

const AccntHolder: React.FC = () => {
  const dispatch = useDispatch();

  const acntHolder = useSelector(
    (state: { router: History; doctorInfo: stateProps }) =>
      state.doctorInfo.acntHolder
  );

  const onInputChange = (event: any) => {
    const { value } = event.target;
    dispatch(enterAcntHolderName(value));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"17"} title={"Account Holder name"} />
        <FormSingleInput
          value={acntHolder}
          onInputChange={onInputChange}
          placeholder={"Account holder’s name"}
        />
      </ContainerBox>
    </React.Fragment>
  );
};

export default AccntHolder;
